import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import noop from "../../../../../core/modules/common/tools/noop";

const CarrierM39ComplianceReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
        label: 'Operator',
      },
      {
        value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
        label: 'Location',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
      {
        value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
    ]}
    {...props}
  />
);
export default CarrierM39ComplianceReport;

CarrierM39ComplianceReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  onSortedChange: noop,
  onFilteredChange: noop,
};
